import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import socialService from "../../services/socialService";

export default function AddSocial(props) {
  const [platform, setPlatform] = useState(null);
  const [handle, setHandle] = useState("");
  const [loading, setLoading] = useState(false);

  const addSocial = (e) => {
    e.preventDefault();
    if (!platform || !handle) {
      toast.error("Fill out both fields");
      return;
    }
    setLoading(true);

    socialService
      .addSocial(handle, platform, props.jwt)
      .then((response) => {
        setLoading(false);
        const newSocials = props.socials.concat(response.data);
        toast.success("Social added");
        props.setSocials(newSocials);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err.response.data.msg || "Error occurred");
      });
  };
  return (
    <div style={{ backgroundColor: "#d3d3d3", height: 300, padding: 6 }}>
      <h4>Add a social</h4>
      <Form>
        <div className="mb-3">
          <Form.Label>Handle</Form.Label>
          <Form.Control
            onChange={(e) => setHandle(e.target.value)}
            id="handle"
            type="text"
            placeholder="@myhandle"
          />
        </div>
        <div className="mb-3">
          <Form.Label>Platform:</Form.Label>
          <Form.Check
            onClick={() => {
              setPlatform("tiktok");
            }}
            name="handleOptions"
            type="radio"
            label="Tiktok"
            id="tiktok"
          />
          <Form.Check
            onClick={() => {
              setPlatform("instagram");
            }}
            name="handleOptions"
            type="radio"
            label="Instagram"
            id="instagram"
          />
        </div>
        {!loading ? (
          <Button
            onClick={addSocial}
            variant="primary"
            type="submit"
            className="col-lg-4"
          >
            Add
          </Button>
        ) : (
          <p>Loading ...</p>
        )}
      </Form>
    </div>
  );
}
